<template>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" @close="close" :close-on-click-modal="false" :close-on-press-escape="false" width="900px">
        <el-form size="small" :model="form" :rules="formRules" :label-width="formLabelWidth" ref="form">

            <el-form-item label="账号">
                <el-select v-model="form.shop_user_id" placeholder="全部" clearable>
                    <el-option v-for="(item, index) in shop_user" :label="item.user_name" :value="item.shop_user_id" :key="item.shop_user_id"></el-option>
                </el-select>
                <div class="tips">小程序后台登录账号，权限--管理员列表添加</div>
            </el-form-item>

            <el-form-item label="名称" prop="name">
                <el-input v-model="form.name" placeholder="名称" clearable/>
            </el-form-item>

            <el-form-item label="地址" prop="address">
                <el-input v-model="form.address" placeholder="地址" clearable/>
            </el-form-item>

            <el-form-item label="状态">
                <el-radio-group v-model="form.status">
                    <el-radio :label="1">启用</el-radio>
                    <el-radio :label="0">禁用</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="排序" prop="sort">
                <el-input v-model.number="form.sort" autocomplete="off"></el-input>
                <div class="tips">越小越靠前</div>
            </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="save" :disabled="submit_loading">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import {companyEdit, companyDetail, shopUserList} from '@/api/education';

    export default {
        components: {  },
        data() {
            return {
                title: '',
                form: {
                    company_id: '',
                    name: '',
                    address: '',
                    shop_user_id: '',
                    sort: 1,
                    status: 1,
                },
                file_path: '',
                /*左边长度*/
                formLabelWidth: '120px',
                /*是否显示*/
                dialogFormVisible: false,
                /*是否正在提交*/
                submit_loading: false,
                // 验证
                formRules: {
                    name: [{
                        required: true,
                        message: '请输入标题',
                        trigger: 'blur'
                    }]
                },
                shop_user: [],
            };
        },
        props: ['fetch-data'],
        created() {

        },
        methods: {
            showDialog(row) {
                if (!row) {
                    this.title = '添加部门'
                } else {
                    this.title = '编辑部门'
                    this.form.company_id = row.company_id
                    this.getDetail()
                }
                this.dialogFormVisible = true
                this.shopList()
            },
            // 关闭
            close() {
                this.$refs['form'].resetFields()
                this.form = this.$options.data().form
                this.dialogFormVisible = false
            },
            // 保存
            save() {
                this.$refs['form'].validate(async (valid) => {
                    if (valid) {
                        this.submit_loading = true
                        companyEdit(this.form).then((result)=>{
                            this.$message({message: result.msg, type: 'success'});
                            this.$emit('fetch-data')
                            this.submit_loading = false
                            this.close()
                        }).catch(()=>{
                            this.submit_loading = false
                        })
                    }
                })
            },
            getDetail(){
                companyDetail({id: this.form.company_id}).then((result)=>{
                    this.form = Object.assign({}, result.data)
                })
            },
            shopList(){
                let par = {page: 1, list_rows: 100,}
                shopUserList(par).then((result)=>{
                    this.shop_user = result.data.list
                })
            },
            courseTypeChange(val){
                this.form.course_type = val
            },
            // 图片上传
            openUpload(e) {
                // this.type = e;
                this.isupload = true;
            },
            /*获取图片*/
            returnImgsFunc(e) {
                if (e != null && e.length > 0) {
                    this.file_path = e[0].file_path;
                    this.form.image_id = e[0].file_id;
                }
                this.isupload = false;
            },

        }
    };
</script>

<style scoped>
    .tips {
        color: #ccc;
    }
</style>



// WEBPACK FOOTER //
// src/views/education/company/edit.vue